import { useTranslation } from "react-i18next"
import { GetProjectResponse, UpdateWorkItemOrderRequest, usePutApiProjectsByProjectIdFoldersAndFolderIdWorkItemsOrderIndexMutation } from "api/generatedApi";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { useToast } from "shared/toast/hooks/use-toast";
import { useWorkItemRestrictions } from "shared/user-restrictions/use-workitems-restrictions";
import { ExtendedProjectFolder } from "pages/project/hooks/use-map-tree-to-flat";
import { SubmitHandler } from "react-hook-form";

interface Props {
  project: GetProjectResponse;
  folder?: ExtendedProjectFolder;
}

export function useSortOrderWorkItems(props: Props) {
  const { project, folder } = props;
  const { t } = useTranslation();

  const { canReOrderWorkItems } = useWorkItemRestrictions(project);
  const toast = useToast();
  const [changeOrderIndex] = usePutApiProjectsByProjectIdFoldersAndFolderIdWorkItemsOrderIndexMutation();



  const wrapMutation = useMutation({
    successProps: {
      description: t("content.measurements.changeOrder.successDescription"),
    },
    resultDialogType: ResultDialogType.Toast,
  });


  const handleOnSubmit: SubmitHandler<UpdateWorkItemOrderRequest> = (data) => {
    wrapMutation(
      changeOrderIndex({
        projectId: project.id ? project.id : "",
        folderId: folder?.projectFolderId ? folder.projectFolderId : "",
        updateWorkItemOrderRequest: data,
      })
    );
  };



  const handleClick = (updateWorkItemOrderRequest: UpdateWorkItemOrderRequest) => {
    if (!canReOrderWorkItems(folder)) {
      toast.error(t("content.measurements.changeOrder.restrictionError"));
      return;
    }

    if (!updateWorkItemOrderRequest.workItemOrderIdAndIndexList || updateWorkItemOrderRequest.workItemOrderIdAndIndexList.length === 0) {
      return;
    }

    handleOnSubmit(updateWorkItemOrderRequest);
  };

  return handleClick;
}
